import mixpanel from "mixpanel-browser";
import Statsig from "statsig-js";
import config from "../../config";

class Analytics {
  constructor() {
    mixpanel.init(config.mixPanelKey, {
      debug: true,
      ignore_dnt: true,
    });
  }

  updateUser(userId) {
    if (userId) {
      mixpanel.identify(userId);
      Statsig.initialize(
        config.statsigKey,
        { userID: userId },
        {
          environment: { tier: config.environment },
          prefetchUsers: [
            {
              userID: userId,
            },
          ],
        }
      ).then(() => {
        Statsig.updateUser({ userID: userId });
      });
    }
  }

  track({ eventName, additionalProps = {} }) {
    try {
      if (config.isEventTrackingEnabled) {
        mixpanel.track(eventName, additionalProps);
        Statsig.logEvent(eventName, eventName, additionalProps);
      }
    } catch (e) {
      console.error(e);
    }
  }

  trackPage(url) {
    try {
      if (config.isEventTrackingEnabled) {
        mixpanel.track_pageview({ page: url });
      }
    } catch (e) {
      console.error(e);
    }
  }
}

const analytics = new Analytics();

export default analytics;
